import React, { useCallback } from "react";
import FetchHook from "../../Api/FetchHooks";
import { useEffect } from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  MenuItem,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useForm } from "react-hook-form";
import PostHooks from "../../Api/PostHooks";
import { LoadingButton } from "@mui/lab";
import AlertComponent from "../../Components/AlertComponent";
import moment from "moment";
import BoostShares from "./component/BoostShares";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ActionDialog from "../../Components/ActionDialog";
import Page from "../../Components/Page";
import TableComponent from "../../Components/TableComponent";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import UseServerTable from "../../Hooks/UseServerTable";
import { formatCurrencyV2, formatDate } from "../../utils/helpers";

const MemberShares = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const location = useLocation();
  const LoggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(location.state?.user || LoggedInUser);
  const [userShares, setUserShares] = useState([]);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // const [loading, response, request] = FetchHook();

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/member_shares?entity_id=${user.id}`,
    onSuccess: (data) => {
      setUserShares(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  // const fetchShares = useCallback(async () => {
  //   await request({
  //     url: `/member_shares?entity_id=${user.id}`,
  //   });
  // }, [user.id]);

  // useEffect(() => {
  //   fetchShares();
  // }, [fetchShares]);

  // useEffect(() => {
  //   if (response && response.data.StatusCode === 0)
  //     setUserShares(response.data.Data);
  // }, [response]);

  const columns = [
    {
      field: "id",
      headerName: "Transaction Id",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "shares",
      headerName: "Shares",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "rate_per_share",
      headerName: "Rate per share",
      minWidth: 150,
      flex: 1,
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "transactional_value",
      headerName: "Transactional value",
      minWidth: 200,
      flex: 1,
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 100,
      flex: 1,
    },
    // {
    //   field: "transfer_id",
    //   headerName: "Transfer id",
    //   minWidth: 150,
    //   flex: 1,
    // },
    {
      field: "debit",
      headerName: "Debit",
      minWidth: 100,
      flex: 1,
      // valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "credit",
      headerName: "Credit",
      minWidth: 100,
      flex: 1,
      // valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    // {
    //   field: "balance_before",
    //   headerName: "Balance before",
    //   minWidth: 150,
    //   flex: 1,
    // },
    {
      field: "balance",
      headerName: "Share Balance",
      minWidth: 100,
      flex: 1,
      // valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    // {
    //   field: "date_created",
    //   headerName: "Start date",
    //   minWidth: 170,
    //   flex: 1,
    //   valueFormatter: (param) =>
    //     moment(param?.value).format("DD/MM/YYYY hh:mm a"),
    // },

    {
      field: "last_updated_on",
      headerName: "Last updated",
      minWidth: 170,
      flex: 1,
      valueFormatter: (param) => formatDate(param?.value),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   minWidth: 100,
    //   flex: 1,
    //   renderCell: (row) => (
    //     <Box>
    //       <Button
    //         variant="outlined"
    //         onClick={() => {
    //           handleModal2();
    //           setShare(row.row);
    //         }}
    //       >
    //         More
    //       </Button>
    //     </Box>
    //   ),
    // },
  ];

  return (
    <>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          sx={{
            py: "25px",
          }}
          title={<Typography variant="h6">Member shares</Typography>}
          action={
            LoggedInUser?.role === "customer" && (
              <Box sx={{ display: "flex", gap: "20px", direction: "row" }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<TrendingUpIcon />}
                  onClick={() => openDialog("boost_shares", "Buy Shares")}
                >
                  Top up shares
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<TrendingDownIcon />}
                  onClick={() => openDialog("sell_shares", "Sell Shares")}
                >
                  Sell shares
                </Button>
              </Box>
            )
          }
        />
        <CardContent>
          {userShares && userShares.length > 0 ? (
            <TableComponent
              data={userShares}
              columns={columns}
              {...gridProps}
            />
          ) : gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <ErrorDisplay
              message="No Shares to display, kindly top up!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default MemberShares;
